import Skeleton from 'react-loading-skeleton';

import Typography from '~/shared/components/Typography';
import ActionTypeDropdown, {
  ActionTypeFilterValue,
} from '~/shared/components/filters/ActionTypeDropdown';

interface OptimizationActionsProps {
  selectedActionType: ActionTypeFilterValue;
  onActionTypeChange: (type: ActionTypeFilterValue) => void;
  typeCounts?: Partial<Record<ActionTypeFilterValue, number>>;
  typeCountsLoading?: boolean;
  allActionsCount?: number;
  allActionsCountLoading?: boolean;
}

export default function OptimizationActions({
  selectedActionType,
  onActionTypeChange,
  typeCounts = {},
  typeCountsLoading = false,
  allActionsCount,
  allActionsCountLoading,
}: OptimizationActionsProps) {
  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        {allActionsCount !== undefined && !allActionsCountLoading ? (
          <Typography fontWeight={500} variant="H5">
            Optimization Actions ({allActionsCount.toLocaleString()})
          </Typography>
        ) : (
          <Skeleton
            containerClassName="block leading-[unset!important]"
            className="h-[20px] leading-[unset!important] rounded-[8px]"
            baseColor="var(--color-gray-200)"
            highlightColor="#FFFF"
            width={150}
          />
        )}
      </div>
      <div className="flex items-center py-2 2xl:py-3">
        <ActionTypeDropdown
          selectedType={selectedActionType}
          onSelect={onActionTypeChange}
          typeCounts={typeCounts}
          typeCountsLoading={typeCountsLoading}
          allActionsCount={allActionsCount}
          allActionsCountLoading={allActionsCountLoading}
        />
      </div>
    </div>
  );
}
